import { render } from "./SidePanel.vue?vue&type=template&id=64e421b1&scoped=true&ts=true"
import script from "./SidePanel.vue?vue&type=script&lang=ts"
export * from "./SidePanel.vue?vue&type=script&lang=ts"

import "./SidePanel.vue?vue&type=style&index=0&id=64e421b1&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src1078960470/src/pricing_engine_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64e421b1"]])

export default __exports__